/**
 * ## listsort selector component
 *
 * @module src/components/listsort
 */

"use strict";

const l = require("../../common").localization;

const selection = null;
let mode = null;
let transfer = null;

/**
 * listsort display.
 */
const create = (options, data, callback) => {
  let thisHTML = '<div id="listsort_shell">';
  thisHTML += '<div id="listsort_data">';
  for (let i = 0; i < data.length; ++i) {
    thisHTML += `<div class="listsort_item listsort_item_data" id="listsort_data_${i}" \
            data-index="${i}">${data[i].description}</div>`;
  }
  thisHTML += "</div>";
  thisHTML +=
    '<div id="listsort_order"><div id="listsort_down"><i class="fa fa-arrow-down" ' +
    'aria-hidden="true"></i></div><div id="listsort_up">' +
    '<i class="fa fa-arrow-up" aria-hidden="true"></i></div></div>';
  thisHTML += `<div class="btn_center"><div id="listsort_save" class="btn9">\
                    ${l.translate("Save Order")}</div></div>`;
  thisHTML += "</div>";
  $(`#${options.target_id}`).html(thisHTML);

  if (options.selection === null) {
    options.selection = 0;
  }

  $("#listsort_button").css("visibility", "visible");
  $("#listsort_button").html("Remove");
  $(".listsort_item").css("background-color", "#444");
  $(`#listsort_data_${options.selection}`).css("background-color", "#999");

  $(".listsort_item_data").off();
  $(".listsort_item_data").fastClick((e) => {
    e.stopPropagation();
    $("#listsort_button").css("visibility", "visible");
    options.selection = $(`#${e.target.id}`).data("index");
    mode = "remove";
    e.stopPropagation();
    $("#listsort_button").html("Remove");
    $(".listsort_item").css("background-color", "#444");
    $(`#${e.target.id}`).css("background-color", "#999");
  });
  $("#listsort_down").fastClick((e) => {
    e.stopPropagation();
    if (options.selection !== null && options.selection + 1 < data.length) {
      transfer = data.splice(options.selection, 1);
      data.splice(options.selection + 1, 0, transfer[0]);
      ++options.selection;
      create(options, data, callback);
    }
  });
  $("#listsort_up").fastClick((e) => {
    e.stopPropagation();
    if (options.selection !== null && options.selection - 1 >= 0) {
      transfer = data.splice(options.selection, 1);
      data.splice(options.selection - 1, 0, transfer[0]);
      --options.selection;
      create(options, data, callback);
    }
  });
  $("#listsort_save").fastClick((e) => {
    e.stopPropagation();
    destroy();
    callback(null, data);
  });
};

const destroy = () => {
  $("#component_catch").css("display", "none");
};

module.exports = {
  create,
  destroy,
};



/** WEBPACK FOOTER **
 ** ./src/components/listsort/index.js
 **/